import { render, staticRenderFns } from "./proUploadImg.vue?vue&type=template&id=d78a2486&"
import script from "./proUploadImg.vue?vue&type=script&lang=js&"
export * from "./proUploadImg.vue?vue&type=script&lang=js&"
import style0 from "./proUploadImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports